module.exports = __webpack_public_path__ + "img/App Logo blue bg.8e751f95.svg";